


















































































import { mdiClose } from '@mdi/js';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NotificationDocModule } from '@/store/modules/notificationsDocuments';
import { NotificationModule } from '@/store/modules/notifications';
import { NotificationType } from '@/utils/dictionaries';
import { RouteName } from '@/router';
import { mapStatementName } from '@/utils/services';

@Component({
  data() {
    return {
      mapStatementName,
      mdiClose,
      NotificationType,
      RouteName,
    };
  },
})
export default class NotificationDocDropDown extends Vue {
  @Prop({ type: String }) title!: string;
  @Prop({ type: String, default: NotificationType.NOTIFICATION })
  notificationType!: string;

  async mounted() {
    switch (this.notificationType) {
      case NotificationType.NOTIFICATION:
        await NotificationModule.getUserTopNotifications();
        break;
      case NotificationType.NOTIFICATION_DOCUMENT:
        await NotificationDocModule.getNotificationsDocNew();
        break;
    }
  }

  get notificationList() {
    switch (this.notificationType) {
      case NotificationType.NOTIFICATION:
        return NotificationModule.topList;
      case NotificationType.NOTIFICATION_DOCUMENT:
        return NotificationDocModule.listNew.map((item: any) => {
          return {
            ...item,
            fullSender: !item.senderOrgName
              ? `${item.senderLastName} ${item.senderName} ${
                  item.senderMiddleName ? item.senderMiddleName : ''
                }`
              : null,
            fullTrustee:
              item.trusteeLastName && item.trusteeName
                ? `${item.trusteeLastName} ${item.trusteeName} ${
                    item.trusteeMiddleName ? item.trusteeMiddleName : ''
                  }`
                : null,
            fullNotary:
              item.notaryLastName && item.notaryName
                ? `${item.notaryLastName} ${item.notaryName} ${
                    item.notaryMiddleName ? item.notaryMiddleName : ''
                  }`
                : null,
          };
        });
      default:
        return [];
    }
  }
}
